import { prepareStackTrace } from 'config/helpers'
import { CONSTS } from 'config/objectConst'
import * as Logs from 'features/logging'
import { NotFoundPage } from 'pages/notfound'
import { useRouteError } from 'react-router-dom'
import { NotExistEntity } from 'shared/errors'
import { useMount } from 'shared/hooks'

import { ErrorPage } from './ErrorPage'

function ErrorBoundary() {
	const error = useRouteError()

	if (error instanceof NotExistEntity) {
		return <NotFoundPage />
	}

	return <ErrorPageWithLogging error={error} />
}

function ErrorPageWithLogging({ error }: { error: unknown }) {
	const isError = error instanceof Error
	const [log] = Logs.api.useLogsMutation()
	useMount(() => {
		if (!CONSTS.LOGS_SETTINGS.didCatch) {
			return
		}

		const stackTrace = prepareStackTrace(error)

		if (stackTrace && isError) {
			log({
				args: [
					`${error.name}:${error.message}`,
					stackTrace,
					CONSTS.APP_VERSION
				],
				event_id: 'AppGenericError',
				message: 'Unhandled app error {Message}, {StackTrace},{Version}',
				severity: 'Error'
			})
		}
	})

	return <ErrorPage />
}

export { ErrorBoundary }
